module.exports = "<div id=\"unauthorized\" *ngIf=\"!authService.isAuthorized\"><div class=\"card mx-auto\" style=\"width: 23rem;\"><div class=\"card-header text-white bg-danger\">{{message}}</div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/unauthorized/unauthorized.component.pug
// module id = ./src/app/unauthorized/unauthorized.component.pug
// module chunks = main